<template>
  <aside class="sidebar">
    <div class="logo-area">
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
        <img src="/logo2.png" alt="Logo" class="sidebar-logo" />
        <h2 style="margin: 0;">绝缘子缺陷检测</h2>
      </div>
      <p>AI 智能巡检中枢</p>
    </div>
    <nav class="side-menu">
      <router-link to="/detect" custom v-slot="{ isActive, navigate }">
        <button :class="['menu-btn', isActive ? 'active' : '']" @click="navigate">
          <template v-if="currentRole === 'admin'">
            <span class="icon">📷</span> <span class="label-desk">缺陷检测</span><span class="label-mobi">缺陷检测</span>
          </template>
          <template v-else><span class="icon">📷</span> 缺陷检测</template>
        </button>
      </router-link>
      <router-link to="/history" custom v-slot="{ isActive, navigate }">
        <button :class="['menu-btn', isActive ? 'active' : '']" @click="navigate">
          <template v-if="currentRole === 'admin'">
            <span class="icon">📊</span> <span class="label-desk">巡检记录</span><span class="label-mobi">巡检记录</span>
          </template>
          <template v-else><span class="icon">📊</span> 巡检记录</template>
        </button>
      </router-link>
      <router-link to="/announcements" custom v-slot="{ isActive, navigate }">
        <button :class="['menu-btn', isActive ? 'active' : '']" @click="navigate">
          <template v-if="currentRole === 'admin'">
            <span class="icon">📢</span> <span class="label-desk">公告通知</span><span class="label-mobi">公告通知</span>
          </template>
          <template v-else><span class="icon">📢</span> 公告通知</template>
        </button>
      </router-link>
      <router-link v-if="currentRole === 'admin'" to="/settings" custom v-slot="{ isActive, navigate }">
        <button :class="['menu-btn', isActive ? 'active' : '']" @click="navigate">
          <span class="icon">⚙️</span> <span class="label-desk">系统配置</span><span class="label-mobi">系统配置</span>
        </button>
      </router-link>
    </nav>
    <div class="user-profile">
      <div class="avatar-circle">{{ (currentUser || '?').charAt(0).toUpperCase() }}</div>
      <div class="user-info">
        <div style="display: flex; align-items: center; gap: 6px;">
          <span class="user-name">{{ currentUser }}</span>
          <button class="rename-btn" @click="handleRenameSelf" title="修改用户名">✏️</button>
        </div>
        <span class="user-role">{{ currentRole === 'admin' ? '系统管理员' : '一线巡检员' }}</span>
      </div>
      <button class="logout-btn" @click="handleLogout" title="退出系统">退出</button>
    </div>
    <div class="sidebar-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号：鄂ICP备2026015730号-1</a><br>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=42050002420970" rel="noreferrer" target="_blank">
        <img src="/beian.png" width="11" />
        鄂公网安备42050002420970号</a>
    </div>
  </aside>
</template>

<script setup>
import { useAuth } from '../composables/useAuth';

const { currentUser, currentRole, handleLogout, getAuthHeaders } = useAuth();

const handleRenameSelf = async () => {
  const newName = prompt('请输入新的用户名：');
  if (newName === null) return;
  if (newName.trim().length < 2) {
    alert('用户名至少需要2个字符');
    return;
  }
  const pwd = prompt('请输入当前密码以确认身份：');
  if (!pwd) return;

  try {
    const res = await fetch('/api/profile/username', {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ new_username: newName.trim(), password: pwd })
    });
    const data = await res.json();
    if (data.status === 'success') {
      localStorage.setItem('username', data.username);
      currentUser.value = data.username;
      alert('✅ 用户名修改成功');
    } else {
      alert('❌ ' + data.message);
    }
  } catch (e) {
    alert('网络请求失败');
  }
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  background-color: var(--color-bg-sidebar);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
}

.logo-area {
  margin-bottom: 50px;
  padding-left: 10px;
}

.sidebar-logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
}

.logo-area h1 {
  font-size: 26px;
  margin: 0 0 8px 0;
  color: #fff;
  letter-spacing: 1px;
}

.logo-area p {
  font-size: 13px;
  color: #1abc9c;
  margin: 0;
  font-weight: bold;
}

.side-menu {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
}

.menu-btn {
  background: transparent;
  color: #bdc3c7;
  border: none;
  font-size: 16px;
  padding: 16px 20px;
  text-align: left;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: bold;
}

.menu-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: white;
}

.menu-btn.active {
  background: #3498db;
  color: white;
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.4);
}

.label-mobi {
  display: none;
}

.sidebar-footer {
  text-align: center;
  font-size: 12px;
  opacity: 0.5;
  margin-top: 15px;
}

.sidebar-footer a {
  color: white;
  text-decoration: none;
}

.sidebar-footer a:hover {
  text-decoration: underline;
}

/* 用户简要档案区块 */
.user-profile {
  margin-top: auto;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  padding: 12px 15px;
  border-radius: 12px;
  gap: 12px;
}

.avatar-circle {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3498db, #8e44ad);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  color: white;
}

.user-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.user-name {
  font-size: 15px;
  font-weight: bold;
  color: white;
}

.user-role {
  font-size: 11px;
  color: #bdc3c7;
}

.logout-btn {
  background: none;
  border: none;
  color: var(--color-danger);
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s;
}

.logout-btn:hover {
  background: rgba(231, 76, 60, 0.1);
}

.rename-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.rename-btn:hover {
  opacity: 1;
}

@media (max-width: 768px) {
  .sidebar {
    position: relative;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    align-items: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    z-index: 10;
  }

  .logo-area {
    margin-bottom: 15px;
    padding-left: 0;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    padding-right: 120px;
    /* 留出右侧空间给悬浮的 user-profile，防止极端情况重叠 */
  }

  .logo-area h1 {
    font-size: 20px;
  }

  .side-menu {
    flex-direction: row;
    width: 100%;
    justify-content: center;
    gap: 10px;
  }

  .menu-btn {
    padding: 10px 10px;
    font-size: 14px;
    flex: 1;
    justify-content: center;
  }

  /* 管理员：移动端隐藏 icon 和长名，显示短名 */
  .menu-btn:has(.label-mobi) .icon {
    display: none;
  }

  .menu-btn:has(.label-mobi) .label-desk {
    display: none;
  }

  .menu-btn:has(.label-mobi) .label-mobi {
    display: inline;
  }

  .sidebar-footer {
    display: none;
  }

  /* 移动端用户标识悬浮至右上方精简展示 */
  .user-profile {
    position: absolute;
    top: 15px;
    right: 15px;
    margin-top: 0;
    padding: 6px 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    gap: 8px;
  }

  .avatar-circle {
    display: none;
    /* 移动端隐藏头像以节省空间 */
  }

  .user-info {
    flex: unset;
  }

  .user-name {
    font-size: 13px;
    font-weight: normal;
  }

  .user-role {
    display: none;
    /* 移动端隐藏角色字样节省空间 */
  }

  .logout-btn {
    padding: 4px 8px;
    font-size: 12px;
  }
}
</style>
